(function () {
  // -------------------------------
  // Helper functions
  // -------------------------------
  function parseDate(d) {
    if (!d) return null;
    // We assume the date is in YYYY-MM-DD format.
    return new Date(d + "T00:00:00");
  }

  // Helper to update urgency notice based on start/enrolment close dates.
  function updateUrgencyNotice(optionEl, productId) {
    let startStr = optionEl.getAttribute("data-start");
    if (!startStr) return;
    let startDate = parseDate(startStr);

    let enrolmentCloseStr = optionEl.getAttribute("data-enrolment-close");
    let enrolmentCloseDate = enrolmentCloseStr
      ? parseDate(enrolmentCloseStr)
      : null;
    let today = new Date();
    let urgencyMessage = "";

    if (today > startDate) {
      // Course has started
      if (enrolmentCloseDate && today <= enrolmentCloseDate) {
        urgencyMessage = "Course started, enrolment still open";
      } else {
        urgencyMessage = "Course Started";
      }
    } else {
      // Course not started yet – if it’s within 5 days, show urgency.
      let fiveDaysFromNow = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000);
      if (startDate <= fiveDaysFromNow) {
        urgencyMessage = "Starting Soon";
      }
    }

    // Find the container for the notices.
    let container = document.querySelector("#course-notice-" + productId);
    if (container) {
      // Look for an existing urgency element.
      let urgencyEl = container.querySelector(".rmit-orange.rmit-small-notice");
      if (urgencyMessage) {
        if (!urgencyEl) {
          urgencyEl = document.createElement("div");
          urgencyEl.className = "rmit-orange rmit-small-notice";
          container.appendChild(urgencyEl);
        }
        urgencyEl.textContent = urgencyMessage;
      } else if (urgencyEl) {
        // If no urgency is needed, remove the element.
        urgencyEl.remove();
      }
    }
  }

  // Loop through all bundle items (starting from the second) and check that the current course’s
  // start date is not before the previous course’s start date and does not overlap its end date.
  function checkOverlaps(container) {
    let bundleCards = container.querySelectorAll(".bundle-col");
    bundleCards.forEach(function (card, index) {
      if (index === 0) return; // first course needs no comparison

      let prevCard = bundleCards[index - 1];
      let prevSelected = prevCard.querySelector(".selected-option");
      let currentSelected = card.querySelector(".selected-option");
      let notice = card.querySelector(".bundle-notice-text");
      notice.style.display = "none";
      notice.innerHTML = "";

      let prevStart = parseDate(prevSelected.getAttribute("data-start"));
      let prevEnd = parseDate(prevSelected.getAttribute("data-end"));
      let currentStart = parseDate(currentSelected.getAttribute("data-start"));
      if (!prevStart || !prevEnd || !currentStart) return;

      if (currentStart < prevStart) {
        notice.style.display = "block";
        notice.innerHTML =
          "The start date of this course overlaps with the previous course.";
      }
      if (currentStart <= prevEnd) {
        notice.style.display = "block";
        notice.innerHTML =
          "The start date of this course overlaps with the previous course. We highly recommend a gap before starting the next course to balance your learning schedule.";
      }
    });
  }

  // For every bundle card beyond the given starting index, auto‑select an option.
  // Logic: If there's a start date that begins AFTER the previous course ends (no overlap),
  // we pick the earliest of those. If none exist, we choose the latest valid date that starts
  // after the previous course's start date (i.e. an overlap scenario) and show a warning.
  function autoSelectSubsequentCourses(container, startingIndex) {
    let bundleCards = Array.from(container.querySelectorAll(".bundle-col"));
    for (var i = startingIndex + 1; i < bundleCards.length; i++) {
      let prevCard = bundleCards[i - 1];
      let currentCard = bundleCards[i];

      let prevSelected = prevCard.querySelector(".selected-option");
      let prevStart = parseDate(prevSelected.getAttribute("data-start"));
      let prevEnd = parseDate(prevSelected.getAttribute("data-end"));
      if (!prevStart || !prevEnd) continue;

      let options = currentCard.querySelectorAll(".option-item");
      let nonOverlappingCandidates = [];
      let overlappingCandidates = [];

      // Gather valid future dates relative to prevStart
      options.forEach(function (item) {
        let startStr = item.getAttribute("data-start");
        let startDate = parseDate(startStr);

        // Block any options that start before the previous course's start
        if (startDate && startDate < prevStart) {
          item.classList.add("blocked");
        } else {
          item.classList.remove("blocked");

          // If the option starts after previous course ends, it's non-overlapping
          if (startDate && startDate > prevEnd) {
            nonOverlappingCandidates.push(item);
          } else if (startDate && startDate >= prevStart) {
            // Overlapping or back-to-back scenario
            overlappingCandidates.push(item);
          }
        }
      });

      // Sort non-overlapping by earliest start
      nonOverlappingCandidates.sort(function (a, b) {
        return (
          parseDate(a.getAttribute("data-start")) -
          parseDate(b.getAttribute("data-start"))
        );
      });

      // Sort overlapping by latest start (so we minimize overlap)
      overlappingCandidates.sort(function (a, b) {
        return (
          parseDate(b.getAttribute("data-start")) -
          parseDate(a.getAttribute("data-start"))
        );
      });

      let bestCandidate = null;
      if (nonOverlappingCandidates.length) {
        // Pick the earliest non-overlapping
        bestCandidate = nonOverlappingCandidates[0];
      } else if (overlappingCandidates.length) {
        // Otherwise, pick the furthest overlapping
        bestCandidate = overlappingCandidates[0];
      }

      // Handle UI
      let selectedOption = currentCard.querySelector(".selected-option");
      let hiddenVariant = currentCard.querySelector(".product-variant-id");
      let currentStart = parseDate(selectedOption.getAttribute("data-start"));

      // Clear selection if the current selection is invalid
      // (i.e. if it started before prevStart)
      if (currentStart && currentStart < prevStart) {
        hiddenVariant.value = "";
        selectedOption.innerHTML =
          "Choose your preferred start date" +
          '<div class="accordion-icon">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M16 4.70797L14.585 3.29297L8 9.87897L1.414 3.29297L0 4.70797L7.999 12.707L16 4.70797Z" fill="#000054"/>' +
          "</svg>" +
          "</div>";
        selectedOption.setAttribute("data-value", "");
        selectedOption.setAttribute("data-start", "");
        selectedOption.setAttribute("data-end", "");
      }

      let notice = currentCard.querySelector(".bundle-notice-text");
      notice.style.display = "none";
      notice.innerHTML = "";

      if (!bestCandidate) {
        // If we can't find any valid or fallback date
        notice.style.display = "block";
        notice.innerHTML = "No valid start date available for this course";
      } else {
        // If user hasn't manually chosen something, or the chosen one was invalid, set bestCandidate
        if (hiddenVariant.value === "") {
          selectedOption.innerHTML =
            bestCandidate.innerHTML +
            '<div class="accordion-icon">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M16 4.70797L14.585 3.29297L8 9.87897L1.414 3.29297L0 4.70797L7.999 12.707L16 4.70797Z" fill="#000054"/>' +
            "</svg>" +
            "</div>";
          selectedOption.setAttribute(
            "data-value",
            bestCandidate.getAttribute("data-value")
          );
          selectedOption.setAttribute(
            "data-start",
            bestCandidate.getAttribute("data-start")
          );
          selectedOption.setAttribute(
            "data-end",
            bestCandidate.getAttribute("data-end")
          );
          hiddenVariant.value = bestCandidate.getAttribute("data-value");

          let productId = bestCandidate.getAttribute("data-product");
          let externalGrayNotice = document.querySelector(
            "#course-notice-" + productId + " .rmit-gray-notice"
          );
          if (externalGrayNotice) {
            externalGrayNotice.textContent =
              bestCandidate.getAttribute("data-formatted");
          }
          // Update urgency notice using our helper.
          updateUrgencyNotice(bestCandidate, productId);

          // Check for overlaps
          checkOverlaps(container);
        }
      }
    }
  }

  // -------------------------------
  // Select toggle & option selection functions
  // -------------------------------
  function selectToggle(e) {
    let parent = e.currentTarget.closest(".custom-select");
    let container = parent.closest(".product-bundle-section");
    let list = parent.querySelector(".options-list");
    let isOpen = list.style.display === "block";

    // Close all other open selects within this section.
    container.querySelectorAll(".options-list").forEach(function (l) {
      l.style.display = "none";
    });
    container.querySelectorAll(".custom-select").forEach(function (cs) {
      cs.classList.remove("open");
    });

    if (!isOpen) {
      list.style.display = "block";
      parent.classList.add("open");
    }
  }

  function selectOption(e) {
    let item = e.target;
    if (!item.classList.contains("option-item")) return;
    if (item.classList.contains("blocked")) return;

    let parent = item.closest(".custom-select");
    let container = parent.closest(".product-bundle-section");
    let list = parent.querySelector(".options-list");
    let selected = parent.querySelector(".selected-option");

    selected.innerHTML =
      item.innerHTML +
      '<div class="accordion-icon">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M16 4.70797L14.585 3.29297L8 9.87897L1.414 3.29297L0 4.70797L7.999 12.707L16 4.70797Z" fill="#000054"/>' +
      "</svg>" +
      "</div>";
    selected.setAttribute("data-value", item.getAttribute("data-value"));
    selected.setAttribute("data-start", item.getAttribute("data-start"));
    selected.setAttribute("data-end", item.getAttribute("data-end"));
    list.style.display = "none";
    parent.classList.remove("open");

    let card = parent.closest(".bundle-col");
    let hiddenVariant = card.querySelector(".product-variant-id");
    hiddenVariant.value = item.getAttribute("data-value");

    let notice = card.querySelector(".bundle-notice-text");
    notice.style.display = hiddenVariant.value ? "none" : "block";

    // Check overlaps for all courses.
    checkOverlaps(container);

    // After a selection is made, auto‑select subsequent courses.
    let bundleIndex = parseInt(card.getAttribute("data-bundle-index"));
    // Adjusting the 1‑based index into a 0‑based one.
    autoSelectSubsequentCourses(container, bundleIndex - 1);

    let productId = card.querySelector('[name="product-id"]').value;
    let externalGrayNotice = document.querySelector(
      "#course-notice-" + productId + " .rmit-gray-notice"
    );
    if (externalGrayNotice) {
      if (item.getAttribute("data-value")) {
        externalGrayNotice.textContent = item.getAttribute("data-formatted");
      } else {
        externalGrayNotice.textContent = "Choose your start date below";
      }
    }

    // Update the urgency notice for this selection.
    updateUrgencyNotice(item, productId);
  }

  // -------------------------------
  // Main initialization for each bundle section
  // -------------------------------
  function initBundleSection(section) {
    let sectionId = section.getAttribute("data-section-id");
    let bundleCards = section.querySelectorAll(".bundle-col");
    let createBundleBtn = section.querySelector(
      "#create-bundle-btn-" + sectionId
    );
    createBundleBtn.disabled = true;
    // Toggle active state on bundle cards.
    bundleCards.forEach(function (card) {
      card.addEventListener("click", function () {
        card.classList.toggle("active");
        createBundleBtn.disabled = false;
      });
    });

    // Set up the custom select dropdowns.
    section.querySelectorAll(".selected-option").forEach(function (el) {
      el.addEventListener("click", selectToggle);
    });
    section.querySelectorAll(".options-list").forEach(function (list) {
      list.addEventListener("click", selectOption);
    });

    // "Get started" button click handler.
    createBundleBtn.addEventListener("click", async function () {
      let btn = this;
      btn.disabled = true;
      btn.innerHTML = "Adding to cart...";

      let valid = true;
      let items = [];

      bundleCards.forEach(function (card) {
        let variantId = card.querySelector(".product-variant-id").value;
        let notice = card.querySelector(".bundle-notice-text");
        notice.style.display = "none";
        notice.innerHTML = "";

        if (!variantId) {
          notice.style.display = "block";
          notice.innerHTML = "Please select a start date";
          valid = false;
        } else {
          let productId = card.querySelector('[name="product-id"]').value;
          items.push({
            id: parseInt(variantId),
            quantity: 1,
            productId: parseInt(productId),
          });
        }
      });

      if (!valid) {
        btn.innerHTML = "Get started";
        btn.disabled = false;
        return;
      }

      // Check if any of the bundled courses are already in the cart — remove them so they get replaced
      try {
        let cartResponse = await fetch("/cart.js");
        let cart = await cartResponse.json();

        let removals = {};
        for (let item of items) {
          let existingItems = cart.items.filter(
            (cartItem) => cartItem.product_id === item.productId
          );
          for (let existingItem of existingItems) {
            removals[existingItem.key] = 0;
          }
        }

        if (Object.keys(removals).length > 0) {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: removals }),
          });
        }
      } catch (error) {
        console.error("Error removing duplicates from cart:", error);
      }

      let bundleName = section.getAttribute("data-product-title");

      try {
        let response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: items.map(function(item) {
              return {
                id: item.id,
                quantity: item.quantity,
                properties: { "_bundle_name": bundleName }
              };
            })
          }),
        });
        let data = await response.json();

        if (data.status === 422) {
          alert(data.message);
          btn.innerHTML = "Get started";
          btn.disabled = false;
          return;
        }

        window.location.href = "/cart";
      } catch (error) {
        console.error("Error adding to cart:", error);
        btn.innerHTML = "Get started";
        btn.disabled = false;
      }
    });
  }

  // -------------------------------
  // Expose the init function (if needed elsewhere)
  // -------------------------------
  window.ProductBundle = {
    init: initBundleSection,
  };

  // -------------------------------
  // Auto‑initialize on DOMContentLoaded and section load events
  // -------------------------------
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".product-bundle-section")
      .forEach(function (section) {
        initBundleSection(section);
      });
  });

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.classList.contains("product-bundle-section")) {
      initBundleSection(e.target);
    }
  });

  // on cart change check if removed bundle is in cart
  document.addEventListener("cart:change", function (e) {
    // console.log(e);
  });

})();
